import { render, staticRenderFns } from "./MoleculeEditionAssetSignedStudentsStudents.vue?vue&type=template&id=242e8e59&"
import script from "./MoleculeEditionAssetSignedStudentsStudents.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetSignedStudentsStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports